module.exports = __webpack_public_path__ + "static/company-banner-image-36ffc8c8dd1482751084df37b5b01eb1.png";